export default {
  "h1-title": "交易工具",
  imgUrlLang: "",
  "public-btn-text": "即刻体验",
  screen0: {
    title: "创建满足您交易需求的工具库",
  },
  screen1: {
    title: "同图商品叠加工具",
    desc: "该工具可以让投资者清晰地了解到两种商品任意周期任意K线的相对强弱，此外还可识别突破的有效性",
  },
  screen2: {
    title: "MACD专业指标(双线)",
    desc: "这是一款股票和期货常用的MACD指标工具，与MT4自带的MACD相比，更加符合中国用户的看盘习惯",
  },
  screen3: {
    title: "MTDriver盈亏统计指标",
    desc: "该工具可以帮助投资者精确地定位不同周期的盈亏",
  },
  screen4: {
    title: "价格变动手机推送通知",
    desc: "大部分投资者的盯盘时间较为有限,价格变动手机推送可以帮助他们在规避部分市场噪音的情况下把握市场的动向",
  },
  screen5: {
    title: "一键平仓EA",
    desc: "操作界面位于图表界面中，方便投资者在极端行情发生的时候更迅速便捷地进行止损",
  },
  screen6: {
    title: "定时下单EA",
    desc: "放在MQL4Experts文件夹下，一款指定时间下单的EA，用法很简单，用户请自行摸索",
  },
  screen7: {
    title: "净值监控EA",
    desc: "放在MQL4Experts文件夹下，监控净值变动的EA，把想要提示的声音文件放在Sounds下，然后在EA的音乐名称填对应音乐文件的名字",
  },
  EA交易与指标: "EA交易与指标",
  EBC独家精选的MT4:
    "EBC独家精选的MT4/MT5指标与EA工具，助您提升决策精准度与操作效率，优化策略，把握市场，获取竞争优势。",
  EBCTurbo账户分析系统:
    "EBC Turbo账户分析系统，深度解析交易表现，优化投资策略。",
  实用型技术指标集: "实用型技术指标集，掌握市场脉动，把握最佳交易时机。",
  外汇EA策略执行器: "外汇EA策略执行器，高效应对市场变化，确保决策始终领先。",
  EBCTurbo账户分析系统2: "EBC Turbo 账户分析系统",
  EBC独家盈亏统计和历史回溯工具:
    "EBC独家盈亏统计和历史回溯工具，基于多维评价系统与深度嵌入模型，全面解析交易细节，助力优化交易策略",
  净值收益曲线: "净值收益曲线",
  收益率: "收益率",
  最大回撤: "最大回撤",
  标准差: "标准差",
  获利系数: "获利系数",
  夏普比率: "夏普比率",
  盈利交易: "盈利交易（胜率）",
  六维评级图: "六维评级图",
  每日: "每日/月度统计",
  获取EBCTurbo: "获取EBC Turbo",
  实用型技术指标集2: "实用型技术指标集",
  经过优化的常用技术指标:
    "经过优化的常用技术指标，支持多角度市场分析与自定义配置，帮助用户精确判断市场动向。",
  同图商品叠加工具: "同图商品叠加工具",
  帮助投资者通过叠加两个商品的走势:
    "帮助投资者通过叠加两个商品的走势，分析它们之间的低阻力线强弱，识别出关键的突破点，提升决策准确性。",
  MACD专业指标: "MACD专业指标(双线)",
  提供比普通MACD更为精准的双线指标:
    "提供比普通MACD更为精准的双线指标，帮助投资者更好地识别市场的买卖信号，从而捕捉更佳的盈利机会。",
  MTDriver盈亏统计指标: "MTDriver盈亏统计指标",
  该指标可协助投资者实时统计不同周期内的盈亏情况:
    "该指标可协助投资者实时统计不同周期内的盈亏情况，为制定更精准的交易策略提供数据支持。",
  价格变动手机推送通知: "价格变动手机推送通知",
  实时监控市场价格波动:
    "实时监控市场价格波动，当出现重大变动时，立即向投资者的手机发送推送通知，确保他们能够在关键时刻做出迅速反应。",
  获取指标: "获取指标",
  外汇EA策略执行器2: "外汇EA策略执行器",
  基于高级算法自动执行EA交易策略:
    "基于高级算法自动执行EA交易策略,实时监控市场并动态调整,确保高效、安全的交易执行。",
  定时下单EA软件: "定时下单EA软件",
  通过MT4EA:
    "通过MT4 EA / MT5 EA预设时间自动执行订单，无需人工干预，适合在特定时间点进行交易的策略，确保交易的及时性与准确性。",
  EA交易常见问题: "EA交易常见问题",
  qaList: [
    {
      q: "1、EA交易是什么?如何运作? ",
      a: [
        "EA交易是指利用智能交易系统在MT4或MT5平台上自动执行交易操作的一种方式。能够根据设定的策略自动买入、卖出、止损止盈，实现无需人工干预的自动化交易，帮助交易者提高执行效率、节省盯盘时间，并减少情绪干扰。",
      ],
    },
    {
      q: "2、不同交易平台的EA软件有什么区别?",
      a: [
        "MT4 EA只能运行在MetaTrader 4平台，使用MQL4语言编写;MT5 EA则基于MetaTrader 5平台，采用MQL5语言，支持更多功能和多线程回测。选择哪种平台取决于交易需求和EA软件的兼容性，两者互不兼容。 ",
      ],
    },
    {
      q: "3、可以在同一平台上运行多个EA软件吗? ",
      a: [
        "可以在同一MetaTrader平台上运行多个EA软件，但需要将每个智能交易系统分别加载到不同的图表中。每个图表中只能运行一个智能交易系统，注意避免它们之间的订单冲突或资源占用问题。 ",
      ],
    },
    {
      q: "4、外汇EA是否可以同时交易多个货币对? ",
      a: [
        "可以，但取决于外汇EA的编写方式。部分智能交易系统仅支持单一货币对，而更强大的智能交易系统可以支持多品种交易。特别是基于MT5 EA的系统，因平台本身支持多线程，处理多品种能力更强。 ",
      ],
    },
    {
      q: "5、如何选择适合自己的外汇EA? ",
      a: [
        "选择外汇EA时应结合自己的交易风格(如趋势跟随或剥头皮)、资金承受能力和风险偏好。查看智能交易系统的历史回测、实盘表现、是否适用于MT4或MT5平台，并先在模拟账户中测试其稳定性和盈利能力。 ",
      ],
    },
    {
      q: "6、EA交易能保证盈利吗? ",
      a: [
        "EA交易的盈利能力取决于其策略逻辑、市场环境以及风控设置。无论是MT4 EA还是MT5 EA，都无法保证长期稳定盈利。市场波动不确定，智能交易系统仅是工具，投资者仍需监控和调整策略。 ",
      ],
    },
  ],
  url:"https://ebcturbo.com/tools?language=zh"
};
